import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogClose } from '@angular/material/dialog';
import { User } from 'projects/core/src/lib/login/data/user';
import { ProfileEditComponent } from '../profile-edit.component';
import { LoginService } from 'projects/core/src/public-api';
import { catchError } from 'rxjs/operators'
import { MvcExceptionResponse } from 'projects/core/src/lib/core/data/mvc-exception-response';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';

@Component({
	selector: 'app-change-password-dialog',
	templateUrl: './change-password-dialog.component.html',
	styleUrls: ['./change-password-dialog.component.scss'],
	providers: [MatDialogClose]
})
export class ChangePasswordDialogComponent implements OnInit {

	currentUser: User

	oldPassword: string;

	newPassword: string;

	confirmedPassword: string;

	showAlert = false;
	alertText: string;

	constructor(
		protected dialog: MatDialog,
		protected dialogClose: MatDialogClose,
		protected loginService: LoginService,
		protected appStateQuery: AppStateQuery
	) { }

	ngOnInit() {
		this.appStateQuery.currentUser$.subscribe(currentUser => this.currentUser = currentUser)
	}

	saveAccountPassword() {
		if (this.confirmedPassword === this.newPassword) {
			this.loginService
				.changePassword(this.oldPassword, this.newPassword)
				.subscribe(success => {
					this.dialogClose.dialogRef.close();
				},
					error => {
						if (error instanceof MvcExceptionResponse) {
							if (error.type === 'login.PasswordMismatchException') {
								this.alertText = error.message
								this.showAlert = true;
							}
							// check other exceptions
						}
					})

		}
		else {
			this.showAlert = true;
			this.alertText = 'Passwords do not match';
		}
	}
}
